export default __webpack_public_path__ + "8501eb0d6af032a6465da3199ae3fe58.woff2";